$(() => {
  $(document).on('scroll', function () {
    $('header#navigation').toggleClass('scrolled', true);
  });
});
